// components
import { MainHeader, TabDropdown, withWindowSizes } from '@edulastic/common'
import { getFormattedAttrId } from '@edulastic/common/src/helpers'
import { roleuser } from '@edulastic/constants'
import { IconSettings } from '@edulastic/icons'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { largeDesktopWidth } from '@edulastic/colors'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { getSchoolAdminSettingsAccess } from '../../../../DistrictPolicy/ducks'
// ducks
import {
  getManageTabLabelSelector,
  getUserRole,
  isOrganizationDistrictSelector,
} from '../../../selectors/user'
import {
  AdminHeaderContent,
  HeaderRightContainer,
  StyledHeaderTabs,
} from './styled'
import { StyledTabs } from '../HeaderTabs'

class AdminHeader extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    active: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  onHeaderTabClick = (key) => {
    const { history, role, isOrganizationDistrictAdmin } = this.props
    // eslint-disable-next-line default-case
    switch (key) {
      case 'administration':
        history.push(`/author/schools`)
        return
      case 'users':
        if (role === 'district-admin' || role === 'school-admin') {
          history.push(`/author/users/teacher`)
        }
        if (isOrganizationDistrictAdmin) {
          history.push(`/author/users/district-admin`)
        }
        return
      case 'settings':
        if (role === roleuser.DISTRICT_ADMIN) {
          history.push(`/author/settings/districtpolicies`)
        } else {
          history.push(`/author/settings/schoolpolicies`)
        }
        return
      case 'content':
        history.push(`/author/content/collections`)
        return
      // case "districtprofile":
      // case "schoolprofile":
      // case "schools":
      // case "classes":
      // case "groups":
      // case "courses":
      // case "class-enrollment":
      default:
        history.push(`/author/${key}`)
    }
  }

  onKeyPressHandler = (
    e,
    currentMenuItem,
    nextMenuItemId,
    previousMenuItemId
  ) => {
    if (e.key === 'Enter') {
      this.onHeaderTabClick(currentMenuItem)
      return
    }
    if (e.key === 'ArrowLeft') {
      const prev = document.getElementById(previousMenuItemId)
      if (prev) prev.focus()
    } else if (e.key === 'ArrowRight') {
      const next = document.getElementById(nextMenuItemId)
      if (next) next.focus()
    }
  }

  onTabKeydownHandler = (e, tabMenuOrder, attrId, action) => {
    const currentMenuItemIndex = tabMenuOrder.indexOf(
      getFormattedAttrId(attrId)
    )
    const nextMenuItemId =
      tabMenuOrder[
        currentMenuItemIndex + 1 > tabMenuOrder.lastIndex
          ? 0
          : currentMenuItemIndex + 1
      ]
    const previousMenuItemId =
      tabMenuOrder[
        currentMenuItemIndex - 1 < 0
          ? tabMenuOrder.lastIndex
          : currentMenuItemIndex - 1
      ]
    this.onKeyPressHandler(e, action, nextMenuItemId, previousMenuItemId)
  }

  render() {
    const {
      active,
      role,
      schoolLevelAdminSettings,
      manageTabLabel,
      children,
      enableStudentGroups,
      windowWidth,
    } = this.props
    const isLargeDesktop = windowWidth <= parseInt(largeDesktopWidth, 10)

    const isDA = role === roleuser.DISTRICT_ADMIN
    const defaultTab = 'Profile'
    const defaultKey = isDA ? 'districtprofile' : 'schoolprofile'
    const activeKey = (active.mainMenu || '')
      .toLocaleLowerCase()
      .split(' ')
      .join('')

    const tabMenuOrder = [
      getFormattedAttrId(`${defaultKey}-tab`),
      getFormattedAttrId('administration-tab'),
      getFormattedAttrId('users-tab'),
      enableStudentGroups ? getFormattedAttrId('groups-tab') : null,
      isDA ? getFormattedAttrId('content-tab') : null,
      isDA || (role === roleuser.SCHOOL_ADMIN && schoolLevelAdminSettings)
        ? getFormattedAttrId('settings-tab')
        : null,
    ].filter((item) => item !== null)
    const getOnKeyDown = (attrId, action) => (e) =>
      this.onTabKeydownHandler(e, tabMenuOrder, attrId, action)

    // ----------------------------- Start of Dropdown Tabs -----------------------------
    const TAB_KEYS = {
      DEFAULT: defaultKey,
      ADMINISTRATION: 'administration',
      USERS: 'users',
      GROUPS: 'groups',
      CONTENT: 'content',
      SETTINGS: 'settings',
    }
    const TAB_LABELS = {
      [TAB_KEYS.DEFAULT]: defaultTab,
      [TAB_KEYS.ADMINISTRATION]: 'Administration',
      [TAB_KEYS.USERS]: 'Users',
      [TAB_KEYS.GROUPS]: 'Groups',
      [TAB_KEYS.CONTENT]: 'Content',
      [TAB_KEYS.SETTINGS]: 'Settings',
    }
    const tabsList = [
      {
        key: TAB_KEYS.DEFAULT,
        component: (
          <StyledHeaderTabs
            id={getFormattedAttrId(`${TAB_KEYS.DEFAULT}-tab`)}
            dataCy={TAB_KEYS.DEFAULT}
            isActive={activeKey === TAB_KEYS.DEFAULT}
            icon={null}
            linkLabel={TAB_LABELS[TAB_KEYS.DEFAULT]}
            onClickHandler={() => this.onHeaderTabClick(defaultKey)}
            aria-controls="profile-tab-panel"
            onKeyDown={getOnKeyDown(`${defaultKey}-tab`, defaultKey)}
          />
        ),
      },
      {
        key: TAB_KEYS.ADMINISTRATION,
        component: (
          <StyledHeaderTabs
            id={getFormattedAttrId(`${TAB_KEYS.ADMINISTRATION}-tab`)}
            dataCy={TAB_KEYS.ADMINISTRATION}
            isActive={activeKey === TAB_KEYS.ADMINISTRATION}
            icon={null}
            linkLabel={TAB_LABELS[TAB_KEYS.ADMINISTRATION]}
            onClickHandler={() =>
              this.onHeaderTabClick(TAB_KEYS.ADMINISTRATION)
            }
            aria-controls="administration-tab-panel"
            onKeyDown={getOnKeyDown(
              `${TAB_KEYS.ADMINISTRATION}-tab`,
              TAB_KEYS.ADMINISTRATION
            )}
          />
        ),
      },
      {
        key: TAB_KEYS.USERS,
        component: (
          <StyledHeaderTabs
            id={getFormattedAttrId(`${TAB_KEYS.USERS}-tab`)}
            dataCy={TAB_KEYS.USERS}
            isActive={activeKey === TAB_KEYS.USERS}
            icon={null}
            linkLabel={TAB_LABELS[TAB_KEYS.USERS]}
            onClickHandler={() => this.onHeaderTabClick(TAB_KEYS.USERS)}
            aria-controls="users-tab-panel"
            onKeyDown={getOnKeyDown(`${TAB_KEYS.USERS}-tab`, TAB_KEYS.USERS)}
          />
        ),
      },
      {
        key: TAB_KEYS.GROUPS,
        component: (
          <>
            {enableStudentGroups && (
              <StyledHeaderTabs
                id={getFormattedAttrId(`${TAB_KEYS.GROUPS}-tab`)}
                dataCy={TAB_KEYS.GROUPS}
                isActive={activeKey === TAB_KEYS.GROUPS}
                icon={null}
                linkLabel={TAB_LABELS[TAB_KEYS.GROUPS]}
                onClickHandler={() => this.onHeaderTabClick(TAB_KEYS.GROUPS)}
                aria-controls="groups-tab-panel"
                onKeyDown={getOnKeyDown(
                  `${TAB_KEYS.GROUPS}-tab`,
                  TAB_KEYS.GROUPS
                )}
              />
            )}
          </>
        ),
      },
      {
        key: TAB_KEYS.CONTENT,
        component: (
          <>
            {isDA && (
              <StyledHeaderTabs
                id={getFormattedAttrId(`${TAB_KEYS.CONTENT}-tab`)}
                dataCy={TAB_KEYS.CONTENT}
                isActive={activeKey === TAB_KEYS.CONTENT}
                icon={null}
                linkLabel={TAB_LABELS[TAB_KEYS.CONTENT]}
                onClickHandler={() => this.onHeaderTabClick(TAB_KEYS.CONTENT)}
                aria-controls="content-tab-panel"
                onKeyDown={getOnKeyDown(
                  `${TAB_KEYS.CONTENT}-tab`,
                  TAB_KEYS.CONTENT
                )}
              />
            )}
          </>
        ),
      },
      {
        key: TAB_KEYS.SETTINGS,
        component: (
          <>
            {(isDA ||
              (role === roleuser.SCHOOL_ADMIN && schoolLevelAdminSettings)) && (
              <StyledHeaderTabs
                id={getFormattedAttrId(`${TAB_KEYS.SETTINGS}-tab`)}
                dataCy={TAB_KEYS.SETTINGS}
                isActive={activeKey === TAB_KEYS.SETTINGS}
                icon={null}
                linkLabel={TAB_LABELS[TAB_KEYS.SETTINGS]}
                onClickHandler={() => this.onHeaderTabClick(TAB_KEYS.SETTINGS)}
                aria-controls="settings-tab-panel"
                onKeyDown={getOnKeyDown(
                  `${TAB_KEYS.SETTINGS}-tab`,
                  TAB_KEYS.SETTINGS
                )}
              />
            )}
          </>
        ),
      },
    ]
    const tabs = isLargeDesktop
      ? tabsList.filter((tab) => tab.key === activeKey)
      : tabsList
    const dropdownTabsList = [
      {
        key: defaultKey,
        name: defaultTab,
      },
      {
        key: TAB_KEYS.ADMINISTRATION,
        name: TAB_LABELS[TAB_KEYS.ADMINISTRATION],
      },
      {
        key: TAB_KEYS.USERS,
        name: TAB_LABELS[TAB_KEYS.USERS],
      },
      {
        key: TAB_KEYS.GROUPS,
        name: TAB_LABELS[TAB_KEYS.GROUPS],
        hideTab: !enableStudentGroups,
      },
      {
        key: TAB_KEYS.CONTENT,
        name: TAB_LABELS[TAB_KEYS.CONTENT],
        hideTab: !isDA,
      },
      {
        key: TAB_KEYS.SETTINGS,
        name: TAB_LABELS[TAB_KEYS.SETTINGS],
        hideTab: !(
          isDA ||
          (role === roleuser.SCHOOL_ADMIN && schoolLevelAdminSettings)
        ),
      },
    ]

    const dropDownTabs = dropdownTabsList.filter(
      (tab) => !tab.hideTab && tab.key !== activeKey
    )
    // ----------------------------- End of Dropdown Tabs -----------------------------
    return (
      <MainHeader
        Icon={IconSettings}
        headingText={manageTabLabel}
        smallDesktopHeaderHeight={50}
        headerLeftClassName="manage-district-headerLeft"
        smallDesktopFlexDirection="row"
      >
        <AdminHeaderContent data-cy="manage-district-header">
          <StyledTabs selectedKeys={[activeKey]} role="tablist">
            {tabs.map((tab) => tab.component)}
          </StyledTabs>
          {isLargeDesktop && (
            <TabDropdown
              onClickHandler={(tab) => this.onHeaderTabClick(tab.key)}
              tabs={dropDownTabs}
            />
          )}
        </AdminHeaderContent>
        <HeaderRightContainer>{children}</HeaderRightContainer>
      </MainHeader>
    )
  }
}

const enhance = compose(
  withWindowSizes,
  connect(
    (state) => ({
      role: getUserRole(state),
      schoolLevelAdminSettings: getSchoolAdminSettingsAccess(state),
      manageTabLabel: getManageTabLabelSelector(state),
      enableStudentGroups: get(state, 'user.user.features.studentGroups'),
      isOrganizationDistrictAdmin: isOrganizationDistrictSelector(state),
    }),
    {}
  )
)
export default enhance(AdminHeader)
